import React from 'react';
import styled, { css } from 'styled-components';


// must be wrapped in label
// https://codesandbox.io/s/yvp79r4251?from-embed=&file=/src/index.js:356-468

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
`

const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 2px;
`
// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

const StyledCheckbox = styled.div`
  display: inline-block;
  width: 16px;
  height: 16px;
  background:  ${({ theme }) => theme.shades.light};
  border: 1px solid  ${({ theme }) => theme.shades.line};
  
  ${props => props.checked && css`
    background: ${({ theme }) => theme.secondary.dark};
  `};

  border-radius: 3px;
  transition: all 150ms;

  ${HiddenCheckbox}:focus + & {
    /* box-shadow: 0 0 0 3px pink; */
  }

  ${Icon} {
    visibility: ${props => (props.checked ? 'visible' : 'hidden')};
  }
`;

export const Checkbox = ({ className, checked, ...props }) => (
  <CheckboxContainer className={className}>
    <HiddenCheckbox checked={checked} {...props} />
    <StyledCheckbox checked={checked}>
      <Icon viewBox="0 0 24 24">
        <polyline points="20 6 9 17 4 12" />
      </Icon>
    </StyledCheckbox>
  </CheckboxContainer>
)